const React = require('react');
const {
  UserContextProvider,
} = require('./src/utils/hooks/useUserContext/context');
require('./src/fonts/ew-font.css');

const wrapRootElement = ({ element }) => {
  return <UserContextProvider>{element}</UserContextProvider>;
};

export { wrapRootElement };
